import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { deleteAccountTierFile } from "../../../../../api/correspondent/CorresspondentApi";
import { useModal } from "../../../../../hooks";
import { DeleteFileType } from "../../../../../types/common/basic";

/**
 * pta 파일삭제 훅
 * @param props
 * @returns
 */
const useDeleteAccountPtaTierFile = () => {
  const queryClient = useQueryClient();
  const { handleModal } = useModal();

  const { mutate } = useMutation({
    mutationFn: (data: DeleteFileType) => deleteAccountTierFile(data),
    onSuccess: (res: any) => {
      if (String(res?.code) === "0000") {
        queryClient.invalidateQueries({
          queryKey: ["readAccountTierInfo"],
        });
        handleModal({
          isOpen: true,
          contents: '파일이 삭제되었습니다.',
          type: "confirm",
        });
        return;
      }
      handleModal({
        isOpen: true,
        contents: res?.msg || '파일 삭제에 실패하였습니다.',
        type: 'alert',
      });
    },
    onError: (error: AxiosError<{ msg?: string }>) => {
          if (error?.response?.data?.msg) {
            handleModal({
              isOpen: true,
              contents: error?.response?.data?.msg,
              type: "alert",
            });
          }
        },
  });
  return { mutate };
};

export default useDeleteAccountPtaTierFile;
